import { render, staticRenderFns } from "./ClaimTypeAvailabilityLabel.vue?vue&type=template&id=7830361c"
import script from "./ClaimTypeAvailabilityLabel.vue?vue&type=script&lang=js"
export * from "./ClaimTypeAvailabilityLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports